import {Component, OnInit} from '@angular/core';
import {QFilterModel} from '../../../../models/qfilter.model';
import {LoyaltyChart} from '../../../../models/loyalty-chart-config.model';
import {IndicatorBoxModel} from '../../../../models/indicator-box.model';
import {SearchToolbarModelFactoryService} from '../../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import {TranslateService} from '@ngx-translate/core';
import {IndicatorsChartService, IndicatorsService} from '../../../../services/indicators/indicators.service';
import {IndicatorsSearchToolbarModel} from '../../../../models/indicators-search-toolbar-model.model';

@Component({
  selector: 'app-analysis-single-store-distribution',
  templateUrl: './analysis-single-store-distribution.component.html',
  styleUrls: ['./analysis-single-store-distribution.component.css']
})
export class AnalysisSingleStoreDistributionComponent implements OnInit {

  public data: QFilterModel;

  public hourlyTransactions: LoyaltyChart;
  public dailyTransactions: LoyaltyChart;
  public indicators: IndicatorBoxModel[] = [];
  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();

  public storeError = false;
  public selectOneError: string;

  public translations: any;

  constructor(
    private translate: TranslateService,
    private indicatorService: IndicatorsService,
    private searchModelFactory: SearchToolbarModelFactoryService,
    private chartsService: IndicatorsChartService
  ) { }

  ngOnInit() {
    this.translations = {
      fatturatoOrario: '',
      fatturatoGiorno: '',
      etichetta_dayofweek: '',
      etichetta_hour: ''
    };

    this.translate.get([
      'store.selectOneErrorMsg',
      'loyalty_chart.fatturato_orario',
      'loyalty_chart.fatturato_giornaliero',
      'store.axis_title_dayofweek',
      'store.axis_title_hour'
    ]).subscribe(t => {
      this.selectOneError = t['store.selectOneErrorMsg'];
      this.translations.fatturatoOrario = t['loyalty_chart.fatturato_orario'];
      this.translations.fatturatoGiorno = t['loyalty_chart.fatturato_giornaliero'];
      this.translations.etichetta_dayofweek = t['store.axis_title_dayofweek'];
      this.translations.etichetta_hour =      t['store.axis_title_hour'];

      this.initCharts();
    });
  }

  private initCharts() {
    this.hourlyTransactions = (new LoyaltyChart('line'));
    this.hourlyTransactions.options.xAxis.title.text = this.translations.etichetta_hour;
    this.dailyTransactions = (new LoyaltyChart('line'));
    this.dailyTransactions.options.xAxis.title.text = this.translations.etichetta_dayofweek;
  }

  setChartInstance(chart: LoyaltyChart, chartInstance) {
    chart.instance = chartInstance;
  }

  searchValueTrend(data: QFilterModel) {
    this.data = data;
    if (data['stores'] != null) {
      this.translate.get([
        'indicator.fatturato',
        'indicator.scontrini',
        'indicator.fatturato_mq',
        'indicator.scontrino_medio',
        'indicator.media_clienti_settimanali',
        'indicator.incidenza_carta',
        'indicator.incidenza_promo',
        'indicator.nuovi_clienti',
        'loyalty_chart.incidenza_carta_store',
        'loyalty_chart.incidenza_carta_format'
      ]).subscribe(t => {
        this.indicators = [];
        this.indicatorService.indicatorCalculation('stores.Q077', this.data).subscribe((res) => {
          this.indicators.push(new IndicatorBoxModel([res.find(ind => ind.name === 'fatturato')], {dynamic: true, unit_period_prec: '€'}, t));
          this.indicators.push(new IndicatorBoxModel([res.find(ind => ind.name === 'scontrini')], {dynamic: true}, t));
          this.indicators.push(new IndicatorBoxModel([res.find(ind => ind.name === 'fatturato_mq')], {decimal_value: 0, decimal_prec_value: 0, unit_period_prec: '€'}, t));
          this.indicators.push(new IndicatorBoxModel([res.find(ind => ind.name === 'incidenza_carta')], {decimal_value: 2, unit_period_prec: '%'}, t));
        });
        this.chartsService.loadChart(this.hourlyTransactions, 'stores.Q100', data, this.indicatorService, this.translate, true);
        this.chartsService.loadChart(this.dailyTransactions, 'stores.Q101', data, this.indicatorService, this.translate, true);
      });
    } else {
      this.data = null;
      this.storeError = true;
    }
  }

  public toogleErrorStoreDialog() {
    this.storeError = !this.storeError;
  }

  public resetData() {
    this.data = null;
    this.indicators = [];
  }
}



// WEBPACK FOOTER //
// ./src/app/views/store/analysis/analysis-single-store-distribution/analysis-single-store-distribution.component.ts